import * as React from 'react';
import { useSelector } from 'react-redux';

import { IApplicationState } from '../../types/redux';
import { EPlatform } from '../../types/platform';
import { MobileFooter } from '../../components/MobileFooter';
import { MOBILE_FOOTER_TYPES } from '../../constants/footerTypes';
import { selectEventCategory } from '../../selectors/eventCategory';
import { trackDownloadAppClick, trackSiteTypeChange } from './tracking';

export const MobileFooterContainer = () => {
  const footerType = useSelector((state: IApplicationState) => state.footerType);
  const platform = useSelector((state: IApplicationState) => state.platform);
  const showSiteTypeChanging = useSelector((state: IApplicationState) => state.showSiteTypeChanging);
  const eventCategory = useSelector(selectEventCategory);

  if (!MOBILE_FOOTER_TYPES.includes(footerType)) {
    return null;
  }

  const handleSiteTypeChange = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    trackSiteTypeChange(eventCategory);

    document.cookie = 'flavour=desktop;path=/;domain=.cian.ru';
    location.reload(true);
  };

  const handleDownloadAppClick = (event: React.MouseEvent<HTMLAnchorElement>, platform: EPlatform) => {
    trackDownloadAppClick({ category: eventCategory, platform });
  };

  return (
    <MobileFooter
      type={footerType}
      platform={platform}
      onSiteTypeChange={handleSiteTypeChange}
      onDownloadAppClick={handleDownloadAppClick}
      withSiteTypeChanging={showSiteTypeChanging}
    />
  );
};
